<template>
	<div id="fotter">
		<span v-for="i in nav" @click="routerChange(i)" :class="(navIndex.index==i.index?'navCheck':'')">
			{{i.name}}
		</span>
	</div>
</template>

<script>
import {mapState, mapMutations} from 'vuex';
export default {
  	name: 'fotter',
	computed:{
		...mapState(['nav','navIndex']),
	},
	data () {
		return {
		}
	},
	created(){
		for(var i in this.nav){
			if(this.nav[i].router == this.$route.path){
				this.navChange(this.nav[i])
			}
		}
	},
	methods: {
		...mapMutations(['navChange']),
		routerChange(data){
      		this.$router.push(data.router)
			this.navChange(data)
		},
	}
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style>
#fotter{
	box-sizing: border-box;
	width: 100%;
	height: 1rem;
	background: url('../assets/img/mobBackground.jpg') repeat center;
	background-size: 100% auto;
	position: fixed;
	bottom: 0px;
	left: 0px;
	z-index: 100;
	box-shadow: 0 0 2px #ccc;
	display: flex;
	flex-direction:row;
	flex-wrap: nowrap;
	justify-content: space-between;
	border-top: #00153b solid 0.08rem;
}
#fotter>span{
	display: inline-block;
	font-size: 0.28rem;
	flex-grow:1;
	line-height: 1rem;
	text-align: center;
	color: #fff;
	font-weight: 900;
}
/* 被选中的 */
.navCheck{
	color: #f5bf00 !important;
}
</style>



// WEBPACK FOOTER //
// src/components/fotter.vue